import React, { Component } from 'react';
import API from '../../api/api';
import './sensitiveWords.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, Input, Modal, message, Popconfirm, ConfigProvider, Alert } from 'antd';
const { TextArea } = Input;

class LiveInfoList extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        waitForCheck: 0,
        loading: false,

        pagination: {
            hideOnSinglePage: true,
            showQuickJumper: false,
            showSizeChanger: false,
            addModalTitle: '',
            // pageSizeOptions: ['10', '20', '30', '40'],
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            position: 'top',
        },
        mainList: [
            // {
            //     userId: '1',
            //     rowId: '1',
            //     userName: '就啊纠结啊姐',
            //     userImage: 'http://s1.im-dangdang.com/20210220/29b89c70-8f5e-4ad0-b322-4dfe12764cb5.jpg',
            //     registTime: "2021-03-11 20:36:44",
            //     wordList: [
            //         {
            //             word: '佛学',
            //             source: '广场',
            //             sourceId: '1',
            //             sourceType: '0', // 0 广场 5 论坛  11 知道 9 秀客
            //         },
            //         {
            //             word: '佛学',
            //             source: '论坛',
            //             sourceId: '1',
            //             sourceType: '5', // 0 广场 5 论坛  11 知道 9 秀客
            //         },
            //         {
            //             word: '佛学',
            //             source: '知道',
            //             sourceId: '1',
            //             sourceType: '11', // 0 广场 5 论坛  11 知道 9 秀客
            //         },
            //     ]
            // },
            // {
            //     userId: '2',
            //     rowId: '2',
            //     userName: '躲猫猫吗',
            //     userImage: 'http://s1.im-dangdang.com/20210220/29b89c70-8f5e-4ad0-b322-4dfe12764cb5.jpg',
            //     registTime: "2021-03-11 20:36:44",
            //     wordList: [
            //         {
            //             word: '佛学',
            //             source: '秀客',
            //             sourceId: '1',
            //             sourceType: '9', // 0 广场 5 论坛  11 知道 9 秀客
            //         },
            //         {
            //             word: '佛学',
            //             source: '论坛',
            //             sourceId: '1',
            //             sourceType: '5', // 0 广场 5 论坛  11 知道 9 秀客
            //         },
            //         {
            //             word: '佛学',
            //             source: '知道',
            //             sourceId: '1',
            //             sourceType: '11', // 0 广场 5 论坛  11 知道 9 秀客
            //         },
            //     ]
            // }
        ],
        columns: [
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '发布人',
                key: 'userName',
                render: (data) => {
                    // const backgroundImage = JSON.parse(data.userImage);
                    return (
                        <div className="userName">
                            <span className='userImage' style={{ backgroundImage: `url(${JSON.parse(data.userImage).picture})` }}></span>
                            <span>{data.userName}</span>
                        </div>
                    )
                }
            },
            {
                title: '注册时间',
                dataIndex: 'registTime',
                key: 'registTime',
            },
            {
                title: '触发敏感词',
                key: 'wordList',
                render: (data) => (
                    <div className="wordList">
                        {
                            data.wordList.map((item, index) => {
                                return <a key={index} onClick={this.goDetail.bind(this, item)}>{`${item.word}（${item.sourceName}）`}</a>
                            })
                        }
                    </div>
                )
            },
            {
                title: '操作',
                key: 'isFreeze',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <Popconfirm title="确定移除该用户吗？"
                            onConfirm={this.deleteFuncOrDis.bind(this, data)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button key={'unFreezeBtn' + data.userId} type="primary" className="deleteBtn">移除</Button>
                        </Popconfirm>
                    </div>
                ),
            },
        ],

        listData: {
            pageNum: 10,
            lastRowId: '',
        },

        swList: '', // 敏感词列表
        userList: '', // 敏感用户ID列表
        SWModal: {
            show: false,
            loading: false,
        },
        SWUserModal: {
            show: false,
            loading: false,
        },

        sourceModel: {
            show: false,
            sourceName: '',
            sourceType: '',
            sourceId: '',
            detail: {
                // sourceType: 11,
                // desc: "在家闲着没事玩的东西真的不要",
                // id: 4601,
                // circleId: '',
                // circleName: '',
                // name: "是不是在线还是没有那么难",
                // createTime: 1615880318,
                // formatCreateTime: "2021-03-11 20:36:44",
                // userId: 1911386,
                // userImage: '{"picture":"http:\/\/s1.im-dangdang.com\/test\/20210205\/7eb0307717d43b44b0edd4dec9a4f1d9.jpg","width":"1080.000000","height":"1080.000000"}',
                // userName: "0020",

                // sourceType:0,
                // content: "本本分分，不耍花招；踏踏实实，不玩手段；简单真诚，不把人害；坦坦荡荡，不欺不骗！",
                // imageArray: ["http://s1.im-dangdang.com/20210311/161546436873083.jpg","http://s1.im-dangdang.com/20210311/161546436873083.jpg","http://s1.im-dangdang.com/20210311/161546436873083.jpg","http://s1.im-dangdang.com/20210311/161546436873083.jpg","http://s1.im-dangdang.com/20210311/161546436873083.jpg"],
                // userName: "杨敢",
                // userImageUrl: "http://s1.im-dangdang.com/user_images/1568543143860346.jpg",
                // createTime: "2021-03-11 20:36:44"

                // sourceType: 5,
                // content: "在家闲着没事玩的东西真的不要<img src='http://s1.im-dangdang.com/user_images/1568543143860346.jpg' />",
                // formatCreateTime: "2021-03-11 20:36:44",
                // userId: 1911386,
                // userImageUrl: "http://s1.im-dangdang.com/user_images/1568543143860346.jpg",
                // userName: "0020",

                // sourceType: 9,
                // title: '是不是在线还是没有那么难',
                // showkeVideo: '{"duration":4,"height":1280,"pictureUrl":"http://s1.im-dangdang.com/test/20210224/4CED23070AB03C2D45044F91E0C8B97C.jpg","videoUrl":"http://s1.im-dangdang.com/FDD36AB4B4C1A993AEAD45CFADE125F7.mp4","width":720}',
                // userImage: '{"picture":"http:\/\/s1.im-dangdang.com\/test\/20210205\/7eb0307717d43b44b0edd4dec9a4f1d9.jpg","width":"1080.000000","height":"1080.000000"}',
                // userName: "0020",
                // formatCreateTime: "2021-03-11 20:36:44"
            },
            // commentList:[{
            //     "images":"[{\"pictureUrl\":\"http://s1.im-dangdang.com/test/20220715/DF4B71997CED2EDAAE50577AA0997D51.png?x-oss-process=image/resize,m_lfit,h_1920,w_1440/format,webp\",\"picture\":\"http://s1.im-dangdang.com/test/20220715/DF4B71997CED2EDAAE50577AA0997D51.png?x-oss-process=image/resize,m_lfit,h_1920,w_1440/format,webp\",\"width\":\"1080\",\"height\":\"1644\",\"isOriginalPic\":\"0\",\"thumbPath\":\"/storage/emulated/0/aladdin/xiu/xiu1645696527743.png\",\"compressUrl\":\"http://s1.im-dangdang.com/test/20220715/DF4B71997CED2EDAAE50577AA0997D51.png?x-oss-process=image/resize,m_lfit,h_1920,w_1440/format,webp\"},{\"pictureUrl\":\"http://s1.im-dangdang.com/test/20220715/8CA97BF777071CC1AFD48F7E0A1CD674.jpg?x-oss-process=image/resize,m_lfit,h_1920,w_1440/format,webp\",\"picture\":\"http://s1.im-dangdang.com/test/20220715/8CA97BF777071CC1AFD48F7E0A1CD674.jpg?x-oss-process=image/resize,m_lfit,h_1920,w_1440/format,webp\",\"width\":\"1080\",\"height\":\"1920\",\"isOriginalPic\":\"0\",\"thumbPath\":\"/storage/emulated/0/Pictures/Screenshots/S20216-17143458.jpg\",\"compressUrl\":\"http://s1.im-dangdang.com/test/20220715/8CA97BF777071CC1AFD48F7E0A1CD674.jpg?x-oss-process=image/resize,m_lfit,h_1920,w_1440/format,webp\"}]",
            //     "text":"还行吧不喜欢小激动",
            // }]
            // commentList: [{
            //     "fromUserName": "alone111圈昵称",
            //     "fromUserImageUrl": "http://s1.im-dangdang.com/test/20210622/4AD32842110A8D65627A4983E764E7F8.png",
            //     "commentContent": "好的V型不会随便",
            //     "detailImages": "{\"picture\":\"http://s1.im-dangdang.com/test/20220715/B6E565C8BD907DD2338399AD1176C89F.jpg\",\"height\":\"2000\",\"width\":\"1504\"}",
            //     "createTime": "1分钟前"
            // }]
        }


    }

    componentDidMount() {
        this.getListData('homePage')
        this.getSWList()
        this.getUserList()
    }
    componentDidUpdate() {

    }


    async getListData(type) {
        let { pagination, listData } = this.state;
        if ('homePage' == type) {
            listData.lastRowId = ''
            pagination.current = 1
        }
        let result = await API.SWMainList(listData);
        if (result.status == 1) {
            let mainList = result.data.mainList;
            if ('homePage' == type && result.data.totalNum <= 10) {
                this.setState({ LiveInfoListPane: true })
            }
            pagination.total = Number(result.data.totalNum);
            this.setState({
                pagination,
                mainList
            })
        }
    }

    async getSWList() {
        let result = await API.SWList();
        if (result.status == 1) {
            let swList = result.data.swList;
            this.setState({
                swList: swList.toString()
            })
        }
    }
    async getUserList() {
        let result = await API.getUser();
        if (result.status == 1) {
            let userList = result.data.userList;
            this.setState({
                userList: userList.toString()
            })
        }
    }




    async getSWList() {
        let result = await API.SWList();
        if (result.status == 1) {
            let swList = result.data.swList;
            this.setState({
                swList: swList.toString()
            })
        }
    }

    async goDetail(item) {
        const { sourceId, sourceType, sourceName } = item;
        console.log('item', item)
        let { sourceModel } = this.state;
        sourceModel.sourceName = sourceName
        sourceModel.sourceType = sourceType
        sourceModel.sourceId = sourceType
        let result = await API.SWSourceDetail({ sourceId, sourceType });
        if (result.status == 1) {
            let detail = result.data.detail;
            sourceModel.detail = detail;
            if (sourceType == '120') {
                sourceModel.commentList = result.data.answerList;
            }
            if (sourceType == '110' || sourceType == '140' || sourceType == '130') {
                sourceModel.commentList = result.data.commentList;
            }
            sourceModel.show = true;
            this.setState({ sourceModel })
        }
    }

    async deleteFuncOrDis(data) {
        let result = await API.SWRemove({ userId: data.userId })
        if (result.status == 1) {
            message.success('移除成功');
            this.getListData();
            return;
        }
        message.error(result.msg);
    }

    handleTableChange = (pagination) => {
        let { listData, mainList } = this.state;
        console.log('pagination.current', pagination.current)
        if (pagination.current == 1) {
            listData.lastRowId = ''
        } else {
            listData.lastRowId = mainList[mainList.length - 1].rowId;
        }
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
            listData
        }, () => {
            this.getListData();
        });
    };

    onShowSizeChange = (current, pageSize) => {
        let { listData, pagination } = this.state;
        pagination.pageSize = pageSize
        pagination.current = 1
        listData.lastRowId = '';
        listData.pageNum = pageSize;
        this.setState({
            pagination,
            listData
        }, () => {
            this.getListData();
        });
    }

    handleAddModalCancel(type) {//添加或编辑对话框点击取消后
        const { SWModal, sourceModel, SWUserModal } = this.state;
        if (type == 'SW') {
            SWModal.show = false;
        }
        if (type == 'source') {
            sourceModel.show = false;
        }
        if (type == 'user') {
            SWUserModal.show = false;
        }

        this.setState({ SWModal, sourceModel, SWUserModal })
    }

    async accessOn() {
        let { swList, SWModal } = this.state;
        SWModal.loading = true
        this.setState({ SWModal });
        console.log('swList', swList)
        let result = await API.addSW({ swList });
        SWModal.show = false;
        SWModal.loading = false;
        this.setState({ SWModal })
        if (result.status == 1) {
            message.success('保存成功')
            this.getListData('homePage');
            return;
        }
        message.error(result.msg)
    }

    async accessUser() {
        let { userList, SWUserModal } = this.state;
        SWUserModal.loading = true
        this.setState({ SWUserModal });
        console.log('userList', userList)
        let result = await API.addUser({ userList });
        SWUserModal.show = false;
        SWUserModal.loading = false;
        this.setState({ SWUserModal })
        if (result.status == 1) {
            message.success('保存成功')
            this.getListData('homePage');
            return;
        }
        message.error(result.msg)
    }


    showModal = () => {
        const SWModal = { ...this.state.SWModal }
        SWModal.show = true;
        this.setState({ SWModal })
    }

    showUserModal = () => {
        let { SWUserModal } = this.state;
        SWUserModal.show = true;
        this.setState({ SWUserModal })
    }

    TextAreaOnChange(e, type) {
        console.log(e.target.value, type);
        if (type == 'SW') {
            this.setState({
                swList: e.target.value
            })
        } else {
            this.setState({
                userList: e.target.value
            })
        }

    }

    render() {
        const {
            columns,
            mainList,
            pagination,
            SWModal,
            swList,
            userList,
            SWUserModal,
            sourceModel,
            LiveInfoListPane
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <div className={`LiveInfoListPane ${LiveInfoListPane ? 'LiveInfoListPane-padding' : ''}`}>
                    <Button type="primary" className='management' onClick={this.showModal}>敏感词管理</Button>
                    <Button type="primary" className='management1' onClick={this.showUserModal}>添加敏感用户</Button>
                    <Table columns={columns}
                        dataSource={mainList}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        onShowSizeChange={this.onShowSizeChange}
                        rowKey={(row, index) => row.userId + '-' + index}
                    />

                    <Modal
                        destroyOnClose={true}
                        title='敏感词'
                        onCancel={this.handleAddModalCancel.bind(this, 'SW')}
                        visible={SWModal.show}
                        width={500}
                        footer={[
                            <Button key="back" onClick={this.handleAddModalCancel.bind(this, 'SW')}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary" loading={SWModal.loading} onClick={this.accessOn.bind(this)}>
                                保存
                            </Button>,
                        ]}
                    >
                        <div className="modalPane">
                            <TextArea rows={8} value={swList} allowClear onChange={(e) => this.TextAreaOnChange(e, 'SW')} />
                            <Alert className='alertError' message="输入敏感词以英文逗号隔开(eg: 佛教,佛学,佛光普照 )" type="error" />
                        </div>
                    </Modal>
                    <Modal
                        destroyOnClose={true}
                        title='敏感用户'
                        onCancel={this.handleAddModalCancel.bind(this, 'user')}
                        visible={SWUserModal.show}
                        width={500}
                        footer={[
                            <Button key="back" onClick={this.handleAddModalCancel.bind(this, 'user')}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary" loading={SWUserModal.loading} onClick={this.accessUser.bind(this)}>
                                保存
                            </Button>,
                        ]}
                    >
                        <div className="modalPane">
                            <TextArea rows={8} value={userList} allowClear onChange={(e) => this.TextAreaOnChange(e, 'user')} />
                            <Alert className='alertError' message="输入敏感用户ID以英文逗号隔开(eg: 1111,2222,3333 )" type="error" />
                        </div>
                    </Modal>
                    <Modal
                        destroyOnClose={true}
                        title={`${sourceModel.sourceName}详情`}
                        onCancel={this.handleAddModalCancel.bind(this, 'source')}
                        visible={sourceModel.show}
                        footer={null}
                    >
                        <div className="modalPane">
                            {
                                (sourceModel.sourceType == '11' || sourceModel.sourceType == '5' || sourceModel.sourceType == '110' || sourceModel.sourceType == '120') &&
                                <div className="displayItem">
                                    <div className="userInfo">
                                        <span className="userImage" style={{ backgroundImage: `url(${sourceModel.detail.userImageUrl ? sourceModel.detail.userImageUrl : JSON.parse(sourceModel.detail.userImage).picture})` }}></span>
                                        <span className="userName">
                                            {sourceModel.detail.userName}
                                        </span>
                                    </div>
                                    {
                                        sourceModel.detail.title &&
                                        <div className="name" dangerouslySetInnerHTML={{ __html: sourceModel.detail.title }}></div>
                                    }
                                    {
                                        sourceModel.detail.name &&
                                        <div className="name" dangerouslySetInnerHTML={{ __html: sourceModel.detail.name }}></div>
                                    }
                                    <div className="content" dangerouslySetInnerHTML={{ __html: sourceModel.detail.desc || sourceModel.detail.content }}></div>
                                    <div className='formatCreateTime'>{sourceModel.detail.formatCreateTime}</div>
                                    {
                                        sourceModel.sourceType == '120' && sourceModel.commentList &&
                                        <div className='commentList'>
                                            <div className='commentTitle'>评论详情</div>
                                            {
                                                sourceModel.commentList[0].images && JSON.parse(sourceModel.commentList[0].images).length > 0 &&
                                                <div className='imageList'>
                                                    {
                                                        JSON.parse(sourceModel.commentList[0].images).map((item, index) => {
                                                            return (
                                                                <div className='imageItem' style={{ backgroundImage: `url(${item.picture})` }}></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                sourceModel.commentList[0].text &&
                                                <div className='text'>{sourceModel.commentList[0].text}</div>
                                            }
                                        </div>
                                    }
                                    {
                                        sourceModel.sourceType == '110' && sourceModel.commentList &&
                                        <div className='commentList'>
                                            <div className='commentTitle'>评论详情</div>
                                            {
                                                sourceModel.commentList[0].detailImages &&
                                                <div className='imageList'>
                                                    <div className='imageItem' style={{ backgroundImage: `url(${JSON.parse(sourceModel.commentList[0].detailImages).picture})` }}></div>
                                                </div>
                                            }
                                            {
                                                sourceModel.commentList[0].commentContent &&
                                                <div className='text'>{sourceModel.commentList[0].commentContent}</div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                sourceModel.sourceType == '0' &&
                                <div className="displayItem">
                                    <div className="userInfo">
                                        <span className="userImage" style={{ backgroundImage: `url(${sourceModel.detail.userImage ? JSON.parse(sourceModel.detail.userImage).picture : sourceModel.detail.userImageUrl})` }}></span>
                                        <span className="userName">
                                            {sourceModel.detail.userName}
                                        </span>
                                    </div>
                                    <div className="content" dangerouslySetInnerHTML={{ __html: sourceModel.detail.content }}></div>
                                    {
                                        sourceModel.detail.imageArray && sourceModel.detail.imageArray.length > 0 &&
                                        <div className='imageArray'>
                                            {
                                                sourceModel.detail.imageArray.map((item, index) => {
                                                    return <span key={index} style={{ backgroundImage: `url(${item})` }}></span>
                                                })
                                            }
                                        </div>
                                    }
                                    <div className='formatCreateTime'>{sourceModel.detail.createTime}</div>
                                </div>
                            }
                            {
                                (sourceModel.sourceType == '9' || sourceModel.sourceType == '140') &&
                                <div className="displayItem">
                                    <div className="userInfo">
                                        <span className="userImage" style={{ backgroundImage: `url(${JSON.parse(sourceModel.detail.userImage).picture})` }}></span>
                                        <span className="userName">
                                            {sourceModel.detail.userName}
                                        </span>
                                    </div>
                                    <div className="content" dangerouslySetInnerHTML={{ __html: sourceModel.detail.title }}></div>
                                    <video controls src={JSON.parse(sourceModel.detail.showkeVideo).videoUrl} poster={JSON.parse(sourceModel.detail.showkeVideo).pictureUrl}></video>
                                    <div className='formatCreateTime'>{sourceModel.detail.formatCreateTime}</div>
                                    {
                                        sourceModel.sourceType == '140' && sourceModel.commentList &&
                                        <div className='commentList'>
                                            <div className='commentTitle'>评论详情</div>
                                            {
                                                sourceModel.commentList[0].detailImages &&
                                                <div className='imageList'>
                                                    <div className='imageItem' style={{ backgroundImage: `url(${JSON.parse(sourceModel.commentList[0].detailImages).picture})` }}></div>
                                                </div>
                                            }
                                            {
                                                sourceModel.commentList[0].commentContent &&
                                                <div className='text'>{sourceModel.commentList[0].commentContent}</div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                sourceModel.sourceType == '130' &&
                                <div className="displayItem">
                                    <div className="userInfo">
                                        <span className="userImage" style={{ backgroundImage: `url(${sourceModel.detail.mediaLogoUrl})` }}></span>
                                        <span className="userName">
                                            {sourceModel.detail.mediaName}
                                        </span>
                                    </div>
                                    <div className="name" dangerouslySetInnerHTML={{ __html: sourceModel.detail.title }}></div>
                                    <div className="content" dangerouslySetInnerHTML={{ __html: sourceModel.detail.content }}></div>
                                    <div className='formatCreateTime'>{sourceModel.detail.formatNewsTime}</div>
                                    {
                                        sourceModel.commentList &&
                                        <div className='commentList'>
                                            <div className='commentTitle'>评论详情</div>
                                            {
                                                sourceModel.commentList[0].detailImages &&
                                                <div className='imageList'>
                                                    <div className='imageItem' style={{ backgroundImage: `url(${JSON.parse(sourceModel.commentList[0].detailImages).picture})` }}></div>
                                                </div>
                                            }
                                            {
                                                sourceModel.commentList[0].commentContent &&
                                                <div className='text'>{sourceModel.commentList[0].commentContent}</div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </Modal>
                </div>
            </ConfigProvider>
        )
    }
}

export default LiveInfoList;